<template>
  <!-- Item -->

    <div class="radio__item" :class="{'isBE' : isBE }">

    <!-- Default input, which is hidden -->

    <input :disabled="available == 0 || exceed == 'yes' || allRoomUnavailable == 'yes'" type="radio" :id="id + '-package'" name="radios" value="" class="radio__input" :checked="isPackageSelected(id)">

    <!-- Content (this needs to be right after radio input for the styles to work properly-->

    <label :for="id + '-package'" class="radio__content">

        <div class="radio__disabled" v-if="exceed == 'yes' || available == 0 ">
            <h3>{{ strings.notavailable }}</h3>
            <p>{{ strings.ohsnap_package }}...</p>
            <ul class="checklist">
                <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="exceed == 'yes'">{{ strings.yourattendees }} ({{ this.$store.state.delegates }}) {{ strings.exceedthelimit }} {{ strings.thispackage }} ({{max}}) </li>
                <li class="checklist__item checklist__item--stack checklist__item--attention" v-if="available == 0">{{ strings.noneofroomavailableinpackage }}</li>
    
            </ul>
        </div>

        <div class="radio__main">

            <!-- Tiny image carousel full screen carousel on click -->

            <div class="tiny-carousel radio__carousel carousel-toggle" :class="{'no-image': checkImage}" @click="openPackageLightBox(0)" :style="{ backgroundImage: `url('${image[0]}')` }">
            </div>

            <div class="radio__head" :class="{'radio_head__be': isBE, 'radio_head_disabled': (available == 0 || exceed == 'yes' || !valid_layout)}">

                <!-- Title -->

                <h2 class="radio__title">{{ title }} <span class="ribbon ribbon--with-icon" v-if="instantBookable == '1'"><img src="../assets/img/icon-flash.svg" alt="" class="ribbon__img"> {{ strings.availableImmediately }}</span></h2>

                <!-- Meta information -->

                <ul class="inline-list inline-list--small radio__meta">
                    <li class="inline-list__item">{{min}}-{{max}} {{ strings.people }}</li>
                </ul>

                <!-- Package Includes -->

                <div class="radio__single-detail packageIncludes">
                    <h4>{{ strings.packageincludes }}</h4>
                    <ul class="checklist">
                        <li v-for="(item,key) in eventsInclude" class="checklist__item" :key="key">
                            {{ item.event_name }} ( {{ showTimeOnly(item.event_start_date) }} - {{showTimeOnly(item.event_end_date)}} )</li>
                    </ul>
                </div>

                <a class="radio__link js-radio-open-details" @click.stop.prevent="toggleDetails()">{{ isHidden ? strings.showdetails : strings.hidedetails }}</a>

            </div>

            <!-- Pricing -->

            <div class="radio__pricing">
                <h3 class="radio__price original_price" v-if="hasReducedPrice && calculatedPrices.price_vat != 0"> {{ currencySymbol }} {{ $store.state.selectedLang === 'de' ? parseFloat(originalPrice / 100).toFixed(2).replace('.' , ',') : parseFloat(originalPrice / 100).toFixed(2) }}  </h3>
                <h3 class="radio__price savings"  v-if="hasReducedPrice && calculatedPrices.price_vat != 0">{{displayDiscountAmount}}</h3>
                <h3 class="radio__price" :class="{'is_seasonal': hasReducedPrice}"  v-if="calculatedPrices.price_vat != 0"> {{ currencySymbol }} {{ $store.state.selectedLang === 'de' ? parseFloat(calculatedPrices.price_vat / 100).toFixed(2).replace('.' , ',') : parseFloat(calculatedPrices.price_vat / 100).toFixed(2) }}  </h3>
                <h3 class="radio__price" v-else>{{ strings.enquiry }}</h3>
                <h4 class="radio__audience" v-if="calculatedPrices.price_vat != 0">{{ strings.perPerson }}</h4>
                <p class="aside__total_be" v-if="calculatedPrices.price_vat != 0">{{strings.total}} <span class="aside__detail">{{strings.inclVAT}}</span> {{ currencySymbol }} {{ parseFloat(totalPrice / 100).toFixed(2) }} <font-awesome-icon v-show="min && min > 1" v-tooltip.right="minPackageCharge" icon="info-circle" /></p>
                <div  v-if="!isRadisson && (calculatedPrices.type == 'disc_price' || calculatedPrices.type == 'disc_price_percentage')">   
                    <p class="ribbon">{{ strings.discountprice }}</p>
                </div>
                <br v-if="!isRadisson && (calculatedPrices.type == 'disc_price' || calculatedPrices.type == 'seasonal_price')" />

                <!-- Event end time -->
                <label class="form__label input-width--20">
                  <span class="timeTitle">{{ strings.endTime }}</span>
                  <select
                    ref="packageEndTime"
                    class="form__input"
                    :value="end"
                    @change="changeEndTime($event)"
                  >
                    <option 
                      v-for="time in timeOptions" 
                      :key="time.id" 
                      :value="time.value"
                      v-if="isWithinPeriod(packageStart, packageEnd, time.value)"
                      >{{ time.text }}</option>
                  </select>
                </label>

                <!-- Event start time -->
                <label class="form__label input-width--20">
                  <span class="timeTitle">{{ strings.starttime }}</span>
                  <select
                    ref="packageStartTime"
                    class="form__input"
                    :value="start"
                    @change="changeStartTime($event)"
                  >
                    <option 
                      v-for="time in timeOptions" 
                      :key="time.id" 
                      :value="time.value"
                      v-if="isWithinPeriod(packageStart, packageEnd, time.value)"
                      >{{ time.text }}</option>
                  </select>
                </label>

                <p class="form__note" v-if="startTimeAfterEndTime" style="text-align: center; font-size:12px; top: 0px; margin-bottom: 0px; float: right;">{{ strings.startTimeBeforeEndTime }}</p>
                <p class="form__note" v-if="!isBookingAllowed" style="text-align: center; font-size:12px; top: 0px; margin-bottom: 0px; float: right;">{{ strings.packageNotAllowed }}</p>

                <button 
                    v-if="isBE && (available == 1 && exceed == 'no') " 
                    href="" :data-id="id" 
                    class="button button--success button--full tabs__button book-now" 
                    @click.stop.prevent="create($event)"
                    :class="{'button--disabled': (isOutsideBusinessHours || startTimeAfterEndTime || isClosed || !isBookingAllowed)}"
                    :disabled="isOutsideBusinessHours || startTimeAfterEndTime || isClosed || !isBookingAllowed"
                    >
                    {{ isInstantBooking? strings.book :strings.sendRequest}}
                </button>
            </div>

        </div>

        <!-- Details -->

        <div class="radio__details js-radio-details" :class="{ 'radio__details--hidden' : isHidden}">

            <!-- Description -->

            <p class="small radio__single-detail packageDescription" v-html="packageDescription"></p>

            <div class="radio__single-detail roomDescription">
                <h4>{{ strings.roomDescription }}</h4>
                <p class="small" v-html="roomDescription"></p>
            </div>

            <!-- Dimensions -->

             <div class="radio__single-detail" v-show="roomHasDimension">

                <h4>{{ strings.roomdimensions }}</h4>

                <ul class="ribbon-list">
                <li class="ribbon-list__item" v-show="roomArea > 0">
                    <span class="ribbon-list__type">{{ strings.area }}: </span> {{ roomArea > 0 ? roomArea + 'm²' : '- ' }}
                </li>
                <li class="ribbon-list__item" v-show="roomHeight > 0">
                    <span class="ribbon-list__type">{{ strings.height }}: </span> {{ roomHeight > 0 ? roomHeight + 'm' : '- ' }}
                </li>
                <li class="ribbon-list__item" v-show="roomWidth > 0">
                    <span class="ribbon-list__type">{{ strings.width }}: </span> {{ roomWidth > 0 ? roomWidth + 'm' : '- ' }}
                </li>
                <li class="ribbon-list__item" v-show="roomLength > 0">
                    <span class="ribbon-list__type">{{ strings.length }}: </span> {{ roomLength > 0 ? roomLength + 'm' : '- ' }}
                </li>
                </ul>

            </div>

            <!-- Equipments -->
            <tabs :options="{ useUrlFragment: false }">
                <tab :name="strings.equipment" v-if="roomEquipment.length > 0">
                <ul class="checklist">
                        <li v-show="!isOpera || roomEquipment.includes(item)" v-for="(item,key) in roomAllEquipment" class="checklist__item" :class="{'checklist__item--not-available': !roomEquipment.includes(item) }" :key="key">{{ item }}</li>
                    </ul>
                </tab>
                <tab :name="strings.equipmentwithfee" v-if="roomEquipmentFee.length > 0">
                    <ul class="checklist">
                        <li v-show="!isOpera || roomEquipmentFee.includes(item)" v-for="(item,key) in roomAllEquipment" class="checklist__item" :class="{'checklist__item--not-available': !roomEquipmentFee.includes(item) }" :key="key">{{ item }}</li>
                    </ul>
                </tab>
            </tabs>

        </div>

    </label>
    <lightbox
         :images="images"
         ref="packageLightbox"
         :showLightBox="false"
         :show-caption="false"
     ></lightbox>
    </div>
</template>

<script>
import Vue from 'vue'
import Lightbox from 'vue-image-lightbox';
import moment from 'moment';
import VueResource from 'vue-resource';
import VTooltip from 'v-tooltip'

import * as hf from '../assets/misc/helperFunctions.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faInfoCircle)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VTooltip);
Vue.use(VueResource);

export default {
    data() {
        return {
            start : this.packageStart,
            end : this.packageEnd,
            startTimeAfterEndTime: false,
            isBookingAllowed: true,
            isHidden : true,
            packageType: this.type,
            packageDescription: this.description,
            images: [],
            timeOptions : [
                {id: 0, text: '00:00' , value: '00:00'},
                {id: 1, text: '00:30' , value: '00:30'},
                {id: 2, text: '01:00' , value: '01:00'},
                {id: 3, text: '01:30' , value: '01:30'},
                {id: 4, text: '02:00' , value: '02:00'},
                {id: 5, text: '02:30' , value: '02:30'},
                {id: 6, text: '03:00' , value: '03:00'},
                {id: 7, text: '03:30' , value: '03:30'},
                {id: 8, text: '04:00' , value: '04:00'},
                {id: 9, text: '04:30' , value: '04:30'},
                {id: 10, text: '05:00' , value: '05:00'},
                {id: 11, text: '05:30' , value: '05:30'},
                {id: 12, text: '06:00' , value: '06:00'},
                {id: 13, text: '06:30' , value: '06:30'},
                {id: 14, text: '07:00' , value: '07:00'},
                {id: 15, text: '07:30' , value: '07:30'},
                {id: 16, text: '08:00' , value: '08:00'},
                {id: 17, text: '08:30' , value: '08:30'},
                {id: 18, text: '09:00' , value: '09:00'},
                {id: 19, text: '09:30' , value: '09:30'},
                {id: 20, text: '10:00' , value: '10:00'},
                {id: 21, text: '10:30' , value: '10:30'},
                {id: 22, text: '11:00' , value: '11:00'},
                {id: 23, text: '11:30' , value: '11:30'},
                {id: 24, text: '12:00' , value: '12:00'},
                {id: 25, text: '12:30' , value: '12:30'},
                {id: 26, text: '13:00' , value: '13:00'},
                {id: 27, text: '13:30' , value: '13:30'},
                {id: 28, text: '14:00' , value: '14:00'},
                {id: 29, text: '14:30' , value: '14:30'},
                {id: 30, text: '15:00' , value: '15:00'},
                {id: 31, text: '15:30' , value: '15:30'},
                {id: 32, text: '16:00' , value: '16:00'},
                {id: 33, text: '16:30' , value: '16:30'},
                {id: 34, text: '17:00' , value: '17:00'},
                {id: 35, text: '17:30' , value: '17:30'},
                {id: 36, text: '18:00' , value: '18:00'},
                {id: 37, text: '18:30' , value: '18:30'},
                {id: 38, text: '19:00' , value: '19:00'},
                {id: 39, text: '19:30' , value: '19:30'},
                {id: 40, text: '20:00' , value: '20:00'},
                {id: 41, text: '20:30' , value: '20:30'},
                {id: 42, text: '21:00' , value: '21:00'},
                {id: 43, text: '21:30' , value: '21:30'},
                {id: 44, text: '22:00' , value: '22:00'},
                {id: 45, text: '22:30' , value: '22:30'},
                {id: 46, text: '23:00' , value: '23:00'},
                {id: 47, text: '23:30' , value: '23:30'},
            ],
        }
    },
    components: {
      Lightbox
    },
    props: [
        'id',
        'title',
        'type',
        'min',
        'max',
        'correctPrice',
        'description',
        'roomDescription',
        'packageIncludes',
        'allIncludes',
        'calculatedPrices',
        'rooms',
        'exceed',
        'available',
        'allRoomExceed',
        'allRoomUnavailable',
        'instantBookable',
        'image',
        'valid_layout',
        'eventsInclude',
        'day',
        'roomArea',
        'roomHeight',
        'roomWidth',
        'roomLength',
        'roomEquipment',
        'roomEquipmentFee',
        'roomAllEquipment',
        'packageStart',
        'packageEnd'
    ],
    methods: {
        checkLeadTime(){
            let baseUrl = this.$store.state.baseUrl;
            let startTime = this.$refs.packageStartTime.value;
            let startD = this.$store.state.date;
            let delegates = this.$store.state.delegates;
            let sentData = {
                'date' : startD + ' ' + startTime,
                'delegates' : delegates,
            }
            let ajaxUrl = baseUrl + '/apiv2/check-lead-times';
            Vue.http.post(ajaxUrl, sentData).then(response => {
                let data = response.body;
                this.isBookingAllowed = data.allow;
                }, response => {
            });
        },
        checkStartEndTime(){
            let startTime = this.$refs.packageStartTime.value;
            startTime = moment(startTime, 'HH:mm');
            let endTime = this.$refs.packageEndTime.value;
            endTime = moment(endTime, 'HH:mm');
            if(startTime.isAfter(endTime) || startTime.isSame(endTime)){
                this.startTimeAfterEndTime = true;
            } else {
                this.startTimeAfterEndTime = false;
            }
        },
        changeStartTime(event){
            this.start = this.$refs.packageStartTime.value;
            this.checkStartEndTime();
            this.checkLeadTime();
        },
        changeEndTime(event){
            this.end = this.$refs.packageEndTime.value;
            this.checkStartEndTime();
        },
        isBeforeEndTime(packageEnd, time){
            packageEnd = moment(packageEnd, 'HH:mm');
            time = moment(time, 'HH:mm');
            return packageEnd.isAfter(time) || packageEnd.isSame(time);
        },
        isAfterStartTime(packageStart, time){
            packageStart = moment(packageStart, 'HH:mm');
            time = moment(time, 'HH:mm');
            return packageStart.isBefore(time) || packageStart.isSame(time);
        },
        isWithinPeriod(packageStart, packageEnd, time){
            packageStart = moment(packageStart, 'HH:mm');
            packageEnd = moment(packageEnd, 'HH:mm');
            time = moment(time, 'HH:mm');
            return (packageEnd.isAfter(time) || packageEnd.isSame(time) ) && (packageStart.isBefore(time) || packageStart.isSame(time));
        },
        showTimeOnly(datetime){
            let timeOnly = moment(datetime, 'YYYY-MM-DDTHH:mm:ss').format('HH:mm');
            return timeOnly;
        },
        openPackageLightBox(index) {
            let allImages;
            this.images = [];
            for (let i=0; i <  this.image.length; i++) {
              allImages = {
                thumb: this.image[i],
                src: this.image[i],
              }
              this.images.push(allImages);
            }

            if(this.image != '') {
                this.$refs.packageLightbox.showImage(index);
            }
        },
        isPackageSelected(packageID){
            if(this.$store.state.selectedPackage == packageID){
              this.$store.commit('detailsTextPackage', this.isHidden);
              return true;
            }
        },
        toggleDetails(){
            //this.$store.commit('togglePackageDetailId', '');
            this.isHidden = !this.isHidden
        },
        create(event){
            const oldCheckOutHosts = ['sjp.cwteasymeetings.com', 'lilly.cwteasymeetings.com', 'interikea.cwteasymeetings.com', 'meetings.leonardohotels.co.uk', 'devere.meetingpackage.com'];
            if (
                oldCheckOutHosts.some(host => host === window.location.host)
            ) {
                this.createBooking(event)
            } else {
                this.createNewBooking(event)
            }
        },
        createBooking(event) {
            //let roomID = event.target.attributes['data-id'].value;
            let _day = this.day;
            let self = this;
            let currentTab = this.currentTab;
            let lang = this.$store.state.selectedLang;
            if(lang == 'en'){
                lang = '';
            } else {
                lang = '/' + lang;
            }
            let chosenItemText = {};
            let packageID = event.target.attributes['data-id'].value;
            if(this.isMoreThanOneDay){

                // Set selected package first.
                this.$store.commit('setSelectedPackageForDay', {
                    'packageID' : packageID,
                    'day' : _day
                });

                let roomList = this.$store.state.rooms_in_package;  // Only 1 room here
                let roomID = '';
                roomList.forEach(element => {
                    roomID = element.id;
                });

                let _event = {};

                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        let start_date = moment(event_el.date, 'DD-MM-YYYY').format("LL");

                        event_el.start_time = this.$refs.packageStartTime.value;
                        event_el.end_time = this.$refs.packageEndTime.value;

                        chosenItemText.event_date = 'Event date: ' + start_date + ' ' + event_el.start_time + ' to ' + event_el.end_time;
                        chosenItemText.delegates = 'Delegates: ' + event_el.delegates;
                        
                        // Loop through all the packages to get the name of selected package.
                        event_el.packages.forEach(package_el => {
                            if(parseInt(package_el.id) == event_el.selected_package){
                                event_el.selected_package_name = package_el.title;
                                event_el.selecled_package_price = package_el.calculated_prices.price_vat;
                                event_el.package_min = package_el.package_min;
                            }
                        });
                        // Get the name of selected room
                        event_el.room_list_in_package.forEach(room_el => {
                            if(parseInt(room_el.id) == parseInt(event_el.selected_room_in_package)){
                                event_el.selected_room_name = room_el.title;
                            }
                        });
                        chosenItemText.package = 'Package: ' + event_el.selected_package_name;
                        chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                        chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayoutinPackage);
                        let tempDelegates = parseInt(event_el.delegates) > parseInt(event_el.package_min) ? parseInt(event_el.delegates) : parseInt(event_el.package_min);
                        chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + (parseFloat(event_el.selecled_package_price) / 100) * tempDelegates;

                        event_el.chosenItemText = chosenItemText;

                        event_el.isChosen = 1;
                        _event = event_el;
                    }
                });
                
                this.$store.commit('setEventList', this.eventList);
                this.$store.commit('pushToFinalEvents', _event);
                this.$store.commit('setTabIndex', parseInt(_day));
            } else {
                this.$store.commit('setSelectedPackage', packageID);
                this.$store.state.packageInfo.forEach(element => {
                    if(element.id == packageID) {
                        this.$store.dispatch('sortRoomListinPackage', element.rooms);
                        //this.$store.commit('setSelectedLayoutinPackage', element.selected_layout);
                    }
                });
                let isOpera = this.$store.state.isOpera;
                let currentTab = this.$store.state.currentTab;
                let isEnquiry = this.$store.state.showEnquiryForm;
                let baseUrl = this.$store.state.baseUrl;

                let startD = '';
                let endD = '';
                let operaStartD = '';
                let operaEndD = '';
                let mt_length = '';

                if(this.currentTab == 'room'){
                    startD = this.$store.state.datetime;
                    operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
                    operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
                    endD = moment(startD, 'DD-MM-YYYY HH:mm');
        
                    if(this.$store.state.meeting_length == 'overnight'){
                        mt_length = 24;
                    } else if(this.$store.state.meeting_length == 'twodays'){
                        mt_length = 36;
                    } else {
                        mt_length = parseInt(this.$store.state.meeting_length);
                    }
        
                    endD = endD.add(mt_length, 'hours');
                    operaEndD = endD;
                    endD = endD.format('DD-MM-YYYY HH:mm');
                    operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');
                } else {
                    let _startD = this.$store.state.date;
                    let packageStartTime = this.$refs.packageStartTime.value;
                    let packageEndTime = this.$refs.packageEndTime.value;

                    startD = _startD + ' ' + packageStartTime;
                    endD = _startD + ' ' + packageEndTime;
                    operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
                    operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
                    operaEndD = moment(endD, 'DD-MM-YYYY HH:mm');
                    operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');
                }
  
    
                this.$store.commit('setProcessing', 'yes');
    
                let roomIF = [];
                let packageIF = [];
                let layout = '';
                let opera_layout_code = '';
                let layout_code = '';
                
                let roomList = this.$store.state.rooms_in_package;  // Only 1 room here
                roomList.forEach(element => {

                    roomIF['id'] = element.id;
                    roomIF['name'] = element.title;
                    roomIF['photo'] = element.room_pictures[0];
                    roomIF['code'] = element.code;
                    roomIF['rate_code'] = '';

                    layout_code = this.$store.state.selectedLayoutinPackage;
                    opera_layout_code = hf.MPLayoutToOperaLayout(layout_code, this.$store.state.venueInfo.operaServer),
                    layout = hf.getLayoutName(layout_code);
                });

                let packageList = this.$store.state.packageInfo;
                packageList.forEach(element => {
                    if(element.id == this.$store.state.selectedPackage){
                        packageIF['name'] = element.title;
                        packageIF['code'] = element.id;
                        packageIF['package_rate_code'] = element.package_rate_code;
                    }
                });

                let type = this.currentTab == 'room' ? 'room' : 'package';
                
                this.$store.dispatch('goToOperaCheckout', {
                    'type' : type,
                    'startD' : startD,
                    'endD' : endD,
                    'operaStartD' : operaStartD,
                    'operaEndD' : operaEndD,
                    'room' : roomIF['name'],
                    'room_id' : roomIF['id'],
                    'room_code' : roomIF['code'],
                    'layout_name' : layout,
                    'layout_code' : layout_code,
                    'opera_layout_code' : opera_layout_code,
                    'room_rate_code' : roomIF['rate_code'],
                    'package' : packageIF['name'],
                    'package_code' : packageIF['code'],
                    'package_rate_code' : packageIF['package_rate_code'],
                    'isInstantBookable': this.instantBookable
                });
    
                return;
                
            }
        },
        createNewBooking(event) {
            //let roomID = event.target.attributes['data-id'].value;
            let _day = this.day;
            let self = this;
            let currentTab = this.currentTab;
            let lang = this.$store.state.selectedLang;
            if(lang == 'en'){
                lang = '';
            } else {
                lang = '/' + lang;
            }
            let chosenItemText = {};
            let packageID = event.target.attributes['data-id'].value;
            if(this.isMoreThanOneDay){

                // Set selected package first.
                this.$store.commit('setSelectedPackageForDay', {
                    'packageID' : packageID,
                    'day' : _day
                });

                let roomList = this.$store.state.rooms_in_package;  // Only 1 room here
                let roomID = '';
                roomList.forEach(element => {
                    roomID = element.id;
                });

                let _event = {};

                this.eventList.forEach(event_el => {
                    if(parseInt(_day) == parseInt(event_el.day)){
                        let start_date = moment(event_el.date, 'DD-MM-YYYY').format("LL");

                        event_el.start_time = this.$refs.packageStartTime.value;
                        event_el.end_time = this.$refs.packageEndTime.value;

                        chosenItemText.event_date = 'Event date: ' + start_date + ' ' + event_el.start_time + ' to ' + event_el.end_time;
                        chosenItemText.delegates = 'Delegates: ' + event_el.delegates;
                        
                        // Loop through all the packages to get the name of selected package.
                        event_el.packages.forEach(package_el => {
                            if(parseInt(package_el.id) == event_el.selected_package){
                                event_el.selected_package_name = package_el.title;
                                event_el.selecled_package_price = package_el.calculated_prices.price_vat;
                                event_el.package_min = package_el.package_min;
                            }
                        });
                        // Get the name of selected room
                        event_el.room_list_in_package.forEach(room_el => {
                            if(parseInt(room_el.id) == parseInt(event_el.selected_room_in_package)){
                                event_el.selected_room_name = room_el.title;
                            }
                        });
                        chosenItemText.package = 'Package: ' + event_el.selected_package_name;
                        chosenItemText.room = 'Room: ' + event_el.selected_room_name;
                        chosenItemText.layout = 'Seating order: ' + hf.getLayoutName(self.$store.state.selectedLayoutinPackage);
                        let tempDelegates = parseInt(event_el.delegates) > parseInt(event_el.package_min) ? parseInt(event_el.delegates) : parseInt(event_el.package_min);
                        chosenItemText.price = 'Price: ' + self.currencySymbol + ' ' + (parseFloat(event_el.selecled_package_price) / 100) * tempDelegates;

                        event_el.chosenItemText = chosenItemText;

                        event_el.isChosen = 1;
                        _event = event_el;
                    }
                });
                
                this.$store.commit('setEventList', this.eventList);
                this.$store.commit('pushToFinalEvents', _event);
                this.$store.commit('setTabIndex', parseInt(_day));
            } else {
                this.$store.commit('setProcessing', 'yes');
                this.$store.commit('setSelectedPackage', packageID);
                this.$store.state.packageInfo.forEach(element => {
                    if(element.id == packageID) {
                        this.$store.dispatch('sortRoomListinPackage', element.rooms);
                        //this.$store.commit('setSelectedLayoutinPackage', element.selected_layout);
                    }
                });
                let isOpera = this.$store.state.isOpera;
                let currentTab = this.$store.state.currentTab;
                let isEnquiry = this.$store.state.showEnquiryForm;
                let baseUrl = this.$store.state.baseUrl;
                let _startD = this.$store.state.date;
                let packageStartTime = this.$refs.packageStartTime.value;
                let packageEndTime = this.$refs.packageEndTime.value;
                let startD = _startD + ' ' + packageStartTime;
                let endD = _startD + ' ' + packageEndTime;
                let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
                operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
                let operaEndD = moment(endD, 'DD-MM-YYYY HH:mm');
                operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');     
    
                let roomIF = [];
                let packageIF = [];
                let layout = '';
                let opera_layout_code = '';
                let layout_code = '';
                
                let roomList = this.$store.state.rooms_in_package;  // Only 1 room here
                roomList.forEach(element => {

                    roomIF['id'] = element.id;
                    roomIF['name'] = element.title;
                    roomIF['photo'] = element.room_pictures[0];
                    roomIF['code'] = element.code;
                    roomIF['rate_code'] = '';

                    layout_code = this.$store.state.selectedLayoutinPackage;
                    opera_layout_code = hf.MPLayoutToOperaLayout(layout_code, this.$store.state.venueInfo.operaServer),
                    layout = hf.getLayoutName(layout_code);
                });


                let ajaxUrl = baseUrl + '/apiv2/create/cart2';
                let selectedPackageInfo = this.$store.state.packageInfo.find(
                    obj => obj.id == this.$store.state.selectedPackage
                )

                let correctDelegates =
                    parseInt(this.$store.state.delegates) < parseInt(selectedPackageInfo.package_min)
                    ? parseInt(selectedPackageInfo.package_min)
                    : parseInt(this.$store.state.delegates)

                let sentData = {};
                sentData.language = this.selectedLang;
                sentData.venue_id = this.$store.state.venueInfo.id;
                sentData.venue_name = this.$store.state.venueInfo.title;
                //sentData.venue_pictures = this.$store.state.venueInfo.venue_pictures;
                sentData.discount_code = this.$store.state.discount_code;
                sentData.delegates = this.$store.state.delegates;
                sentData.order_type = currentTab;
                sentData.venue_type_en = this.$store.state.venueInfo.venue_type_en;
                sentData.country_code = this.$store.state.venueInfo.country_code;
                sentData.city = this.$store.state.venueInfo.city;
                sentData.events = [
                    {
                        'start' : startD,
                        'end' : endD,
                        'currency' : this.$store.state.venueInfo.currency_code,
                        'room' : {
                            'id' : roomIF['id'],
                            'name' : roomIF['name'],
                            'layout_code' : layout_code,
                            'isInstantBookable' : this.instantBookable
                        },
                        'package' : {
                            'id' : selectedPackageInfo.id,
                            'name' : selectedPackageInfo.title,
                            'rate_code' : selectedPackageInfo.package_rate_code,
                            'package_min': parseInt(selectedPackageInfo.package_min),
                            'total_price': selectedPackageInfo.calculated_prices.price_vat * correctDelegates,
                            'unit_price': selectedPackageInfo.calculated_prices.price_vat,
                            'price_type': selectedPackageInfo.calculated_prices.type,
                            'includes': selectedPackageInfo.events,
                        }
                    }
                ];
                Vue.http.post(ajaxUrl, sentData).then(response => {
                    let data = response.body;
                    let url = baseUrl + lang + '/book-universal/' + data;
                    if(this.isRadisson){
                        url = baseUrl + '/book-universal/' + data;
                    }
                    window.location.href = url;
                    }, response => {
                });
            }
        },
    },
    computed: {
        isRadisson(){
            return window.isRadisson == '1' ? true : false
        },
        originalPrice(){
            if(this.correctPrice && this.correctPrice.original_price){
                return this.correctPrice.original_price;
            }else{
                return 0;
            }
        },
        hasReducedPrice(){
            if(window.location.hostname === 'interikea.cwteasymeetings.com'){
                return false;
            }
            return this.originalPrice > this.calculatedPrices.price_vat;
        },
        displayDiscountAmount(){
            return ( (this.originalPrice - this.calculatedPrices.price_vat) / this.originalPrice * 100 ).toFixed(0) + "% " + this.$store.state.strings.savings;
        },
        isInstantBooking(){
            return this.instantBookable == '1' && !(this.available == 0 || this.exceed == 'yes' || !this.valid_layout)
        },
         roomHasDimension(){
            return this.roomArea > 0 || this.roomHeight > 0 || this.roomWidth > 0 || this.roomLength > 0
        },
        isClosed(){
            return this.$store.state.isClosed;
        },
        isOpera() {
            return this.$store.state.isOpera;
        },
        minPackageCharge(){
            return (this.min && this.min > 1 && parseInt(this.$store.state.delegates) < parseInt(this.min)) ? this.$store.state.strings.minimumcharge + ' ' + this.min + " " +  this.$store.state.strings.people + ', ' + this.$store.state.strings.butyoucan: '';
        },
        totalPrice(){
            let packageMin;
            if(this.isMoreThanOneDay){
                // Get the event list.
                let operaEventList = this.operaEventList;
                operaEventList.forEach(event => {
                    if(parseInt(event.day) == parseInt(this.day)){
                        packageMin = parseInt(event.delegates) > parseInt(this.min) ? parseInt(event.delegates) : parseInt(this.min);
                    }
                });
            } else {
                if(parseInt(this.$store.state.delegates) > parseInt(this.min)){
                    packageMin = this.$store.state.delegates;
                }   else{
                     packageMin = this.min;
                }
            }
            return this.calculatedPrices.price_vat * packageMin;
        },
        operaEventList() {
            return this.$store.state.eventList;
        },
        isMoreThanOneDay() {
            return this.$store.state.isMoreThanOneDay;
        },
        eventList() {
            return this.$store.state.eventList;
        },
        isOutsideBusinessHours(){
            return this.$store.state.isOutsideBusinessHours;
        },
        isBE(){
            return this.$store.state.isBE;
        },

        checkImage() {
            if(this.image == '') {
                return true;
            }
            else {
                return false
            }
        },
        currencySymbol(){
            return this.$store.state.currencySymbol;
        },
        strings(){
            return this.$store.state.strings;
        },
        pType(){
            let pType = this.packageType;
            let strings = this.$store.state.strings;
            switch (this.packageType) {
                case '4':
                    pType = strings.halfdaypackage;
                    break;
                case '8':
                    pType = strings.fulldaypackage;
                    break;
                case '24':
                    pType = strings.overnightpackage;
                    break;
                case '36':
                    pType = strings.twodayspackage;
                    break;

            }
            return pType;
        },
        roomInfo() {
            this.$store.state.packageInfo.forEach(element => {
                if(element.id == packageID) {
                    return element.rooms;
                }
            });
        },
        activeTranslate() {
            return this.$store.state.isTranslated;
        },
        selectedLang () {
            return this.$store.state.selectedLang;
        },
        toggleDetail() {
          return this.$store.state.togglePackageDetailId;
        },
        currentTab() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.description, lang: this.$store.state.selectedLang }).then((data)=>{
                this.packageDescription = data;
                });
            } else {
                this.packageDescription = this.description;
            }
            return this.$store.state.currentTab;
        }
    },
    watch: {
        packageStart(value) {
            let self = this;
            Vue.nextTick(function () {
                self.start = value;
            })
            
        },
        packageEnd(value) {
            let self = this;
            Vue.nextTick(function () {
                self.end = value;
            })
        },
        activeTranslate() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.description, lang: this.$store.state.selectedLang }).then((data)=>{
                this.packageDescription = data;
                });
            } else {
                this.packageDescription = this.description;
            }
        },
        selectedLang() {
            if (this.$store.state.isTranslated) {
                this.$store.dispatch('gTranslateRoom', { text: this.description, lang: this.$store.state.selectedLang }).then((data)=>{
                this.packageDescription = data;
                });
            } else {
                this.packageDescription = this.description;
            }
        },
        available: function(newValue) {
            if(newValue == 0){
                this.isHidden = true;
            }
        },
        exceed: function(newValue){
            if(newValue == 'yes'){
                this.isHidden = true;
            }
        },
        allRoomUnavailable: function(newValue){
            if(newValue == 'yes'){
                this.isHidden = true;
            }
        }
    }
}
</script>

<style scoped>
    .radio__item.isBE {
        background: #fff;
        margin: 20px 0 20px 0;
    }

    .radio input[type=radio]:disabled+.radio__content {
        height: auto;
        min-height: 190px;
    }

    button {
        outline: none;
    }

    .no-border-bottom {
        border-bottom: none;
    }

    .new_seating_order{
        display: none;
    }

    .isBE .new_seating_order ul {
        flex-wrap: wrap !important;
    }

    .isBE .new_seating_order ul li {
        flex: none !important;
        margin-bottom: 5px !important;
    }

    .isBE .radio__content {
        border-left: none !important;
        cursor: inherit !important;
    }

    .isBE .radio__content:after, .isBE .radio__content:before {
        content: none !important;
    }

    .radio .isBE input[type=radio]:checked+.radio__content {
        background-color: white;
        box-shadow: inset 0 0 0 1px #e0e0e0;
    }

    .radio__pricing_disabled .radio__price, .radio__pricing_disabled .radio__audience, .radio__pricing_disabled .ribbon, .radio__pricing_disabled .radio__audience, .radio__pricing_disabled  .radio__audience, .radio_head_disabled, .new_seating_order_disabled{
        opacity: 0.4;
    }
    .radio__pricing_disabled .checklist__item--attention, .roomitemList .checklist__item--attention{
        background:none;
        padding:0px;
    }
    .attentionImage{
        border: none;
        width: 15px;
        height: 15px;
        vertical-align: bottom;
    }
    @media (min-width: 639px){
        .isBE .radio__carousel {
            width: 400px;
            height: 200px;
            cursor: pointer;
        }

        .new_seating_order{
            display: block;
            width: 25%;
            max-width: 300px
        }

    }


    .packageIncludes .checklist__item {
        width: 100%;
    }

    .input-width--20 {
        width: 49%;
        margin-right: 1%;
        float: right;
    }

    @media (min-width: 639px){
        button.book-now {
            width: 62%;
            margin-right: 2%;
        }

        .input-width--20 {
            width: 30%;
            margin-right: 2%;
            float: right;
            margin-top: 20px;
            margin-bottom: 20px;
        }

        .isBE .radio_head_disabled{
            flex: 0 3 70%!important;
        }

        .radio_head_disabled{
            flex: 0 1 70%!important;
        }
            
        .radio_head__be {
            flex: 0 3 70% !important;
        }
    }

    .timeTitle {
        float: left;
    }
    a {
        cursor: pointer;
    }
</style>
